import { IsUrl } from "class-validator";

export class GetDemoDashboardLinkResult {
    @IsUrl()
    dashboardLink: string;
}